import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { UserService } from '@frontend/sports/user/feature';
import { WINDOW } from '@frontend/vanilla/core';

import { RedirectHelperService } from '../navigation-core/redirect-helper.service';

@Injectable({ providedIn: 'root' })
export class PrintGuard {
    constructor(
        private userService: UserService,
        private redirectHelper: RedirectHelperService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const inIFrame = this.isInIframe();
        const hasSkipRedirectInRoute = route.queryParams && route.queryParams.skipRedirect && JSON.parse(route.queryParams.skipRedirect);
        if (!hasSkipRedirectInRoute && !inIFrame) {
            this.redirectHelper.goHome();

            return false;
        }

        if (!this.userService.username) {
            this.redirectHelper.goToLogin({ forceReload: true });

            return false;
        }

        return true;
    }

    private isInIframe(): boolean {
        try {
            return this.#window.self !== this.#window.top;
        } catch (e) {
            return true;
        }
    }

    readonly #window = inject(WINDOW);
}
